/*
  RAWS bundle picks: the cart drawer's "Build your bundle" carousel and quick view.
  Loaded from layout/theme.liquid, after raws-cart-cro.js.

  1. The theme fills the carousel with Shopify's related products for ONE cart item (it passes
     cart.items[0], the newest). Here the picks are mixed from up to three cart items (newest
     first, taking turns), and anything already in the cart is left out. It asks for the same
     section HTML the theme does, so the cards look and work exactly as before. If anything
     fails, the theme's own loading runs instead.
  2. Quick view opens on the size the shopper last tapped this visit (raws_size_pick, saved by
     raws-cart-cro.js) when that size exists and is in stock. raws-cart-cro.js then counts it
     as picked, so Add to cart goes straight through.
*/
(function () {
  'use strict';
  if (window.__rawsBundlePicks) return;
  window.__rawsBundlePicks = true;

  var MAX_SEEDS = 3;
  var CACHE_MS = 5 * 60 * 1000;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var cache = {};

  // Related products for a product don't depend on the cart, so reopening the drawer reuses them.
  function getText(url) {
    var hit = cache[url];
    if (hit && Date.now() - hit.t < CACHE_MS) return hit.p;
    var p = fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .catch(function () { return ''; });
    cache[url] = { t: Date.now(), p: p };
    return p;
  }

  function findHost(html, id) {
    if (!html || !id) return null;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var sel = '#' + (window.CSS && CSS.escape ? CSS.escape(id) : id);
    var el = doc.querySelector(sel);
    if (el) return el;
    var tpls = doc.querySelectorAll('template');
    for (var i = 0; i < tpls.length; i++) {
      el = tpls[i].content.querySelector(sel);
      if (el) return el;
    }
    return null;
  }

  function slidesOf(host) {
    return host ? Array.prototype.slice.call(host.querySelectorAll('[data-carousel-container] > .card-carousel__slide')) : [];
  }

  function productIdOf(slide) {
    var card = slide.querySelector('[data-id]');
    return card ? String(card.getAttribute('data-id')) : '';
  }

  function patchPicks(Related) {
    var proto = Related && Related.prototype;
    if (!proto || proto.__rawsPicks || typeof proto.loadProducts !== 'function') return;
    proto.__rawsPicks = true;
    var original = proto.loadProducts;

    proto.loadProducts = function () {
      var self = this;
      var url = this.dataset.url;
      if (!url || !/[?&]product_id=\d+/.test(url) || typeof this.updateByHTML !== 'function') {
        return original.apply(this, arguments);
      }

      function fallBack() {
        self.__rawsKey = null;
        self.prevUrl = null;
        try { original.apply(self); } catch (err) {}
      }

      fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var inCart = {};
          var seeds = [];
          (cart.items || []).forEach(function (item) {
            var id = String(item.product_id);
            if (!inCart[id]) {
              inCart[id] = true;
              seeds.push(id);
            }
          });
          // Reload only when what's in the cart changes (the theme reloads only when the first item does).
          var key = url.replace(/([?&]product_id=)\d+/, '$1') + '|' + seeds.join(',');
          if (self.__rawsKey === key) return;
          self.__rawsKey = key;
          self.prevUrl = url;
          if (!seeds.length) return;

          if (self.showPreloader) self.showPreloader();
          return Promise.all(seeds.slice(0, MAX_SEEDS).map(function (id) {
            return getText(url.replace(/([?&]product_id=)\d+/, '$1' + id));
          })).then(function (texts) {
            if (self.hidePreloader) self.hidePreloader();
            if (self.__rawsKey !== key) return;

            var hosts = texts.map(function (t) { return findHost(t, self.id); });
            var lists = hosts.map(slidesOf);
            var host = null;
            for (var i = 0; i < hosts.length; i++) {
              if (lists[i].length) { host = hosts[i]; break; }
            }
            host = host || hosts[0];
            if (!host) return fallBack();

            // Take turns between the cart items' lists: one new pick from each per round.
            var limit = parseInt((url.match(/[?&]limit=(\d+)/) || [])[1], 10) || 10;
            var picked = [];
            var seen = {};
            var more = true;
            while (picked.length < limit && more) {
              more = false;
              for (var s = 0; s < lists.length && picked.length < limit; s++) {
                while (lists[s].length) {
                  var slide = lists[s].shift();
                  var pid = productIdOf(slide);
                  if (!pid || inCart[pid] || seen[pid]) continue;
                  seen[pid] = true;
                  picked.push(slide);
                  break;
                }
                if (lists[s].length) more = true;
              }
            }

            var box = host.querySelector('[data-carousel-container]');
            if (box) {
              while (box.firstChild) box.removeChild(box.firstChild);
              for (var j = 0; j < picked.length; j++) box.appendChild(picked[j]);
            }
            var wrap = document.createElement('div');
            wrap.appendChild(host);
            self.updateByHTML(wrap);
          });
        })
        .catch(fallBack);
    };
  }

  if (window.customElements) {
    var Related = customElements.get('cart-drawer-related-products');
    if (Related) {
      patchPicks(Related);
    } else {
      customElements.whenDefined('cart-drawer-related-products').then(function () {
        patchPicks(customElements.get('cart-drawer-related-products'));
      });
    }
  }

  // Quick view: open on the shopper's size.
  var SIZE_NAME = /size|größe|grösse|taille|maat|talla|taglia|サイズ|사이즈|storlek|størrelse|koko|tamanho/i;
  var PICK_KEY = 'raws_size_pick';
  var PICK_TTL = 6 * 60 * 60 * 1000;

  function lastPick() {
    try {
      var p = JSON.parse(window.sessionStorage.getItem(PICK_KEY) || 'null');
      return p && p.v && Date.now() - p.t < PICK_TTL ? String(p.v) : null;
    } catch (err) {
      return null;
    }
  }

  function preselect(picker) {
    var pick = lastPick();
    if (!pick || picker.__rawsPre === pick) return;
    picker.__rawsPre = pick;

    var containers = picker.querySelectorAll('[data-variant-picker-option-inputs]');
    var wanted = [];
    var target = null;
    for (var i = 0; i < containers.length; i++) {
      var inputs = containers[i].querySelectorAll('input[type="radio"]');
      var value = null;
      for (var j = 0; j < inputs.length; j++) {
        var input = inputs[j];
        if (SIZE_NAME.test(input.name || '')) {
          if (input.value === pick) { target = input; value = pick; }
        } else if (input.checked) {
          value = input.value;
        }
      }
      wanted.push(value);
    }
    if (!target || target.checked || wanted.indexOf(null) !== -1) return;

    var variants = [];
    try {
      variants = JSON.parse(picker.querySelector('script[data-variant-picker-variants]').textContent);
    } catch (err) {
      return;
    }
    var inStock = variants.some(function (v) {
      return v.available && v.options && v.options.join('\u0000') === wanted.join('\u0000');
    });
    if (!inStock) return;

    target.checked = true;
    target.dispatchEvent(new Event('change', { bubbles: true }));
    var group = picker.querySelector('[data-variant-picker-option-labels][option-picker-name="' + target.name.replace(/"/g, '\\"') + '"]');
    if (group) group.classList.remove('raws-size-unset');
  }

  function scan() {
    var pickers = document.querySelectorAll('quick-view variant-picker');
    for (var i = 0; i < pickers.length; i++) preselect(pickers[i]);
  }

  var queued = false;
  function queueScan() {
    if (queued) return;
    queued = true;
    setTimeout(function () {
      queued = false;
      scan();
    }, 60);
  }
  scan();
  if (window.MutationObserver) {
    new MutationObserver(queueScan).observe(document.body, { childList: true, subtree: true });
  }
})();